export class PuntajePrueba{
    constructor(
        public credencial: number,
        public idprueba: any,
        public puntaje: any
    ){}
}